/** Coordinate pins and deep links; Pebble owns the dialog and carousel behavior. */
class SourcingMap extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.dialogComponent = this.querySelector("dialog-component");
    this.dialog = this.querySelector("dialog");
    this.content = this.querySelector("[data-sourcing-content]");
    this.addEventListener(
      "click",
      (event) => {
        const pin = event.target.closest("[data-popup-template]");
        if (pin && this.contains(pin)) this.openPin(pin);
      },
      { signal },
    );
    this.dialogComponent.addEventListener(
      "dialog:close",
      () => {
        this.activePin?.setAttribute("aria-expanded", "false");
        const url = new URL(location.href);
        if (url.searchParams.get("handle") === this.activePin?.dataset.handle) {
          url.searchParams.delete("handle");
          history.replaceState(history.state, "", url);
        }
        this.content.replaceChildren();
      },
      { signal },
    );
    window.addEventListener("popstate", () => this.syncLocation(), { signal });
    document.addEventListener(
      "shopify:block:select",
      (event) => {
        const pin = event.target.matches?.("[data-popup-template]")
          ? event.target
          : event.target.querySelector?.("[data-popup-template]");
        if (pin && this.contains(pin)) this.openPin(pin);
      },
      { signal },
    );
    customElements.whenDefined("dialog-component").then(() => {
      if (this.isConnected) this.syncLocation();
    });
  }

  syncLocation() {
    const handle = new URLSearchParams(location.search).get("handle");
    const pin =
      handle && this.querySelector(`[data-handle="${CSS.escape(handle)}"]`);
    if (pin) this.openPin(pin);
    else if (this.dialog.open) this.dialogComponent.closeDialog();
  }

  async openPin(pin) {
    await customElements.whenDefined("dialog-component");
    if (!this.isConnected || (this.dialog.open && this.activePin === pin))
      return;
    const template = document.getElementById(pin.dataset.popupTemplate);
    if (!template || !this.contains(template)) return;
    this.activePin?.setAttribute("aria-expanded", "false");
    this.activePin = pin;
    pin.setAttribute("aria-expanded", "true");
    this.content.replaceChildren(template.content.cloneNode(true));
    this.dialog.scrollTop = 0;
    this.dialogComponent.showDialog();
    const url = new URL(location.href);
    if (pin.dataset.handle) {
      url.searchParams.set("handle", pin.dataset.handle);
      history.replaceState(history.state, "", url);
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
    if (this.dialog?.open) this.dialogComponent.closeDialog();
  }
}

if (!customElements.get("sourcing-map")) {
  customElements.define("sourcing-map", SourcingMap);
}
